import MyTabs from '../../components/MyTabs';
import Section1 from './Section1.js'

const GeneralCalendarEvents = () => {

    const tabs = [
        { id: "Basic", title: "Basic Calendar Event Info", Component: Section1 },
    ];

    return (
        <MyTabs list={tabs} />
    )
};

export default GeneralCalendarEvents;